import Enum from "./Enum";

export default class HttpMethod extends Enum {

    /** @var string */
    static GET     = 'GET';

    /** @var string */
    static POST    = 'POST';

    /** @var string */
    static PUT     = 'PUT';

    /** @var string */
    static DELETE  = 'DELETE';

    /** @var string */
    static PATCH   = 'PATCH';

    /** @var string */
    static HEAD    = 'HEAD';

    /** @var string */
    static TRACE   = 'TRACE';

    /** @var string */
    static OPTIONS = 'OPTIONS';

    /** @var string */
    static CONNECT = 'CONNECT';

    /**
     * Check if given method is POST
     *
     * @param {string} [method]
     * @returns {boolean}
     */
    static isPost(method?: string) {
        if (! method) return false;

        return method.toUpperCase() === this.POST;
    }

    /**
     * Check if given method is PUT
     *
     * @param {string} [method]
     * @returns {boolean}
     */
    static isPut(method?: string) {
        if (! method) return false;

        return method.toUpperCase() === this.PUT;
    }
}

